import { Link } from "react-router";
import { Nett } from "../footer/Nett";
import { handleOpenChat } from "utils/analytics";

export default function Footer() {
  return (
    <>
      <div className="w-full px-5 lg:px-10 py-5 bg-gray-50 border border-gray-100 bg-top">
        <footer className="flex justify-around flex-wrap max-w-screen-xl mx-auto">
          <div className="w-80 p-5">
            <p className="mb-2">Endereço</p>
            <p className="font-light">Rua do Sol N 270</p>
            <p className="font-light">Praia de Barra Grande</p>
            <p className="font-light">Maragogi - Alagoas</p>
          </div>
          <div className="w-80 p-5 flex flex-col">
            <p className="mb-2">Sitemap</p>
            <Link to="/" className="font-light">
              Home
            </Link>
            <Link to="/a-pousada" className="font-light">
              A Pousada
            </Link>
            <Link to="/acomodacoes" className="font-light">
              Acomodações
            </Link>
            <Link to="/como-chegar" className="font-light">
              Localização
            </Link>
          </div>
          <div className="w-80 p-5">
            <p className="mb-2">Fale conosco</p>
            <p className="font-light">reservas@beachpointmaragogi.com.br</p>
            <p className="font-light">wa.me/5581982402330</p>
            <p className="font-light">+55 (81) 98240-2330</p>
          </div>
          <div className="w-80 p-5">
              <p className="mb-2">Segue a gente</p>
              <div className="flex">
                <a href="https://www.instagram.com/beachpointbarragrande">
                  <img className="h-8 mr-8" src="/insta.png" alt="beachpointmaragogi" />
                </a>
                <button onClick={handleOpenChat} type="submit">
                  <img className="h-8" src="/wpp.png" alt="Peromar" />
                </button>
              </div>
          </div>
        </footer>
      </div>
      <Nett />
    </>
  )
}